<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import ChooseCsvModal from "@/views/pages/calendar/modals/ChooseCsvModal.vue";
import CalendarDisplayMonth from "@/components/Calendars/CalendarDisplayMonth.vue";

export default {
  name: "CalendarSetting",
  page: {
    title: "カレンダ設定",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    CalendarDisplayMonth,
    ChooseCsvModal,
  },
  data() {
    return {
      isLoading: false,
      data: []
    }
  },
};
</script>
<template>
  <Layout>
    <div class="calendar-settings">
      <b-card>
        <ChooseCsvModal />
        <CalendarDisplayMonth
          style="width: 100%"
          :isCheckedEvent="false"
          :className="'setting_admin_calendar'"
          class="setting_admin_calendar setting_admin_calendar_display_month"
        />
      </b-card>
    </div>
  </Layout>
</template>
<style scoped lang="scss">
.calendar-settings {
 font-size: 14px;
}
</style>
